import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    const path =
      location.pathname +
      location.search +
      location.hash;

    // Google Analytics 4
    if (typeof window.gtag === "function") {
      window.gtag("event", "page_view", {
        page_path: path,
        page_location: window.location.href,
        page_title: document.title,
      });
    }

    // Meta Pixel
    if (
      typeof window.fbq === "function" &&
      window.__ZEDRO_META_LAST_PAGEVIEW__ !== path
    ) {
      window.fbq("track", "PageView");
      window.__ZEDRO_META_LAST_PAGEVIEW__ = path;
    }
  }, [location]);

  return null;
}